import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicyScreen: React.FC = () => {
  return (
    <div className="privacy-policy-container container">
      <h1>Política de Privacidade — Mimo Cupido</h1>
      <p>
        <strong>Última atualização:</strong> Maio de 2026
      </p>

      <p>
        A prioridade da empresa <strong>66.154.541 SILVANA ALVES</strong>,
        inscrita no CNPJ sob nº
        <strong> 66.154.541/0001-82</strong>, nome fantasia{" "}
        <strong>Mimo Cupido</strong>, é assegurar a privacidade e a segurança
        das informações cedidas por Você (“USUÁRIO”) durante a utilização de
        todos os serviços, plataformas, websites e aplicativos do Mimo Cupido.
      </p>

      <p>
        Esta Política de Privacidade abrange o uso de nossos sistemas nos
        domínios:
      </p>
      <ul>
        <li>www.mimocupido.com.br e todos os subdomínios associados.</li>
      </ul>

      <p>
        Neste sentido, o Mimo Cupido envidará seus melhores esforços para
        garantir a proteção dos seus dados pessoais e a sua privacidade.
      </p>

      <p>
        O Mimo Cupido, de maneira específica, coleta e utiliza algumas
        informações de identificação pessoal necessárias para atingir os fins
        descritos nesta Política de Privacidade. Ao manifestar o seu
        consentimento por meio do pop-up de aceitação, Você reconhece e aceita a
        coleta, tratamento e processamento de seus dados pessoais pelo Mimo
        Cupido conforme descrito neste instrumento.
      </p>

      <hr />

      <h2>Índice</h2>
      <ol>
        <li>Definições</li>
        <li>
          Informações Pessoais Coletadas e Sua Utilização pelo Mimo Cupido
        </li>
        <li>Do Consentimento dos Usuários</li>
        <li>Com Quem o Mimo Cupido Compartilha as Suas Informações</li>
        <li>Transferências Dentro do Território Nacional</li>
        <li>Transferências Internacionais de Dados</li>
        <li>Período de Retenção e Armazenamento de Dados</li>
        <li>Direitos e Garantias dos Titulares</li>
        <li>Segurança da Informação</li>
        <li>Encarregado de Proteção de Dados</li>
        <li>Disposições Gerais</li>
      </ol>

      <hr />

      <h2>1. Definições</h2>
      <p>
        Para fins desta Política de Privacidade, aplicam-se as seguintes
        definições:
      </p>
      <ul>
        <li>
          <strong>Websites:</strong> sítios eletrônicos desenvolvidos para o
          Mimo Cupido e acessíveis através do endereço: www.mimocupido.com.br e
          quaisquer subdomínios associados.
        </li>
        <li>
          <strong>Cookies:</strong> arquivos enviados pelo servidor do Mimo
          Cupido para o navegador do Usuário com a finalidade de identificar o
          dispositivo e personalizar a navegação.
        </li>
        <li>
          <strong>Dado Pessoal:</strong> informação relacionada a pessoa natural
          identificada ou identificável.
        </li>
        <li>
          <strong>Encarregado de Proteção de Dados:</strong> pessoa indicada
          para atuar como canal de comunicação entre o controlador, os titulares
          e a ANPD.
        </li>
        <li>
          <strong>Tratamento de Dados Pessoais:</strong> toda operação realizada
          com dados pessoais, incluindo coleta, armazenamento, uso,
          compartilhamento, eliminação e demais formas previstas na LGPD.
        </li>
        <li>
          <strong>IP:</strong> conjunto numérico que identifica o dispositivo do
          Usuário na internet.
        </li>
        <li>
          <strong>Logs:</strong> registros de atividades dos Usuários efetuados
          nos sistemas do Mimo Cupido.
        </li>
        <li>
          <strong>Usuário:</strong> pessoa física maior de 18 anos que acessa ou
          utiliza os serviços do Mimo Cupido.
        </li>
        <li>
          <strong>Visitante:</strong> pessoa que acessa os websites do Mimo
          Cupido com ou sem cadastro.
        </li>
        <li>
          <strong>Produtos:</strong> sistemas, serviços e funcionalidades
          disponibilizadas pelo Mimo Cupido.
        </li>
        <li>
          <strong>Plataformas:</strong> websites, aplicativos e sistemas do Mimo
          Cupido.
        </li>
        <li>
          <strong>Session ID:</strong> informação armazenada em cookie utilizada
          para autenticação e acesso à plataforma.
        </li>
        <li>
          <strong>Web beacons:</strong> linhas de programação utilizadas para
          análise de navegação e comportamento do Usuário.
        </li>
        <li>
          <strong>Dados de uso:</strong> informações coletadas automaticamente,
          incluindo IP, tempo de acesso, páginas visitadas, tipo de dispositivo,
          navegador e demais informações técnicas.
        </li>
      </ul>

      <h2>
        2. Informações Pessoais Coletadas e Sua Utilização pelo Mimo Cupido
      </h2>
      <p>
        O Mimo Cupido valoriza a transparência e a proteção da identidade
        digital dos Usuários.
      </p>
      <p>
        Ao utilizar nossos serviços, websites e aplicativos, Você poderá
        fornecer voluntariamente seus dados pessoais. Além disso, determinadas
        informações poderão ser coletadas automaticamente durante sua navegação.
      </p>

      <h3>Dados Cadastrais Coletados</h3>
      <p>O Mimo Cupido poderá coletar:</p>
      <p className="dados-coletados">
        Nome, E-mail, Senha, Data de nascimento, Cidade, Fotografias,
        Escolaridade, Profissão, Filhos, Relacionamento, Cor e etnia, Corpo,
        Cabelo, Olhos, Altura, Frase de apresentação, Bebidas, Cigarros,
        Expectativa de estilo de vida, Disponibilidade para viajar, O que está
        buscando, Sobre mim, Renda mensal e Patrimônio.
      </p>

      <h3>Finalidades do Tratamento</h3>
      <p>Os dados poderão ser utilizados para:</p>
      <ul>
        <li>Identificação do Usuário;</li>
        <li>Funcionamento adequado da plataforma;</li>
        <li>Exibição de perfis compatíveis;</li>
        <li>Segurança e prevenção de fraudes;</li>
        <li>Melhorias nos serviços;</li>
        <li>Comunicação com o Usuário;</li>
        <li>Marketing e personalização de experiência;</li>
        <li>Cumprimento de obrigações legais.</li>
      </ul>

      <h3>Dados Coletados Automaticamente</h3>
      <p>Durante a navegação poderão ser coletados:</p>
      <ul>
        <li>IP, data e hora de acesso e geolocalização;</li>
        <li>Navegador utilizado, tempo de visita e páginas acessadas;</li>
        <li>
          Dados do dispositivo, sistema operacional, operadora e velocidade da
          conexão;
        </li>
        <li>Cookies e device IDs.</li>
      </ul>

      <h2>3. Do Consentimento dos Usuários</h2>
      <p>
        Ao acessar e utilizar os websites e plataformas do Mimo Cupido, o
        Usuário declara estar ciente e concordar com os termos desta Política de
        Privacidade.
      </p>
      <p>
        Ao utilizar formulários do website, o Usuário concorda expressamente
        com:
      </p>
      <ul>
        <li>A coleta de dados pessoais e o tratamento das informações;</li>
        <li>Os Termos de Uso e esta Política de Privacidade.</li>
      </ul>

      <h2>4. Com Quem o Mimo Cupido Compartilha as Suas Informações</h2>
      <p>O Mimo Cupido poderá compartilhar informações com:</p>
      <ul>
        <li>Profissionais autorizados e prestadores de serviços;</li>
        <li>Parceiros comerciais e plataformas de tecnologia;</li>
        <li>
          Serviços de hospedagem em nuvem e ferramentas de análise e marketing;
        </li>
        <li>Autoridades públicas e governamentais quando exigido por lei.</li>
      </ul>
      <p>
        Os dados compartilhados sempre observarão medidas adequadas de segurança
        e confidencialidade.
      </p>

      <h2>5. Transferências Dentro do Território Nacional</h2>
      <p>
        Os dados poderão ser tratados e armazenados em servidores localizados no
        Brasil por empresas parceiras contratadas pelo Mimo Cupido.
      </p>

      <h2>6. Transferências Internacionais de Dados</h2>
      <p>
        Caso haja necessidade de transferência internacional de dados, o Mimo
        Cupido adotará mecanismos adequados de proteção, conforme exigido pela
        Lei Geral de Proteção de Dados (LGPD).
      </p>

      <h2>7. Período de Retenção e Armazenamento de Dados</h2>
      <p>O Mimo Cupido manterá seus dados:</p>
      <ul>
        <li>Enquanto houver relação ativa com o Usuário;</li>
        <li>Enquanto necessário para cumprimento legal;</li>
        <li>
          Para proteção contra fraudes e para exercício regular de direitos.
        </li>
      </ul>
      <p>
        Os dados serão armazenados em ambiente seguro e acessíveis apenas por
        pessoas autorizadas.
      </p>

      <h2>8. Direitos e Garantias dos Titulares</h2>
      <p>Nos termos da LGPD, o Usuário poderá solicitar:</p>
      <ul>
        <li>Confirmação da existência de tratamento e acesso aos dados;</li>
        <li>
          Correção de dados incompletos, anonimização, bloqueio ou eliminação;
        </li>
        <li>
          Portabilidade, revogação do consentimento e informações sobre
          compartilhamentos.
        </li>
      </ul>
      <p>
        Solicitações poderão ser realizadas através do e-mail:
        <a href="mailto:atendimento@mimocupido.com">
          {" "}
          atendimento@mimocupido.com
        </a>
      </p>

      <h2>9. Segurança da Informação</h2>
      <p>
        O Mimo Cupido adota medidas técnicas e organizacionais aptas a proteger
        os dados pessoais contra acessos não autorizados, perda, alteração ou
        divulgação indevida.
      </p>
      <p>
        Contudo, nenhum sistema é completamente seguro, razão pela qual o Mimo
        Cupido não poderá garantir segurança absoluta contra ataques externos ou
        ações maliciosas de terceiros.
      </p>

      <h2>10. Encarregado de Proteção de Dados</h2>
      <p>
        O encarregado de proteção de dados do Mimo Cupido poderá ser contatado
        através do e-mail:
        <a href="mailto:atendimento@mimocupido.com">
          {" "}
          atendimento@mimocupido.com
        </a>
      </p>

      <h2>11. Disposições Gerais</h2>
      <p>
        Esta Política poderá ser alterada a qualquer momento mediante publicação
        da versão atualizada em: <strong>www.mimocupido.com.br</strong>
      </p>
      <p>
        O presente documento será interpretado conforme a legislação brasileira.
      </p>
      <p>
        Fica eleito o foro da Comarca de <strong>Piracicaba/SP</strong> para
        dirimir quaisquer controvérsias relacionadas a esta Política de
        Privacidade.
      </p>

      <p>
        Em caso de dúvidas, sugestões ou solicitações relacionadas aos serviços
        do Mimo Cupido, entre em contato através do e-mail:
        <a href="mailto:atendimento@mimocupido.com">
          {" "}
          atendimento@mimocupido.com
        </a>
      </p>
    </div>
  );
};

export default PrivacyPolicyScreen;
